import React from 'react';
import PropTypes from 'prop-types';

const HeartIcon = ({ width = '24', height = '24', fill = 'currentColor', className = '', stroke = 'currentColor' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      className={className}
    >
      {/* Circle around the heart */}
      <circle cx="12" cy="12" r="11" fill="none" stroke={stroke} strokeMiterlimit="10" />

      {/* Heart shape - using a better proportioned heart that fits nicely in the circle, positioned lower */}
      <path
        d="M12 19c-0.5 0-1-0.2-1.4-0.6l-5.2-5.2c-1.7-1.7-1.7-4.4 0-6.1 0.8-0.8 1.9-1.3 3.1-1.3 1.2 0 2.3 0.5 3.1 1.3l0.4 0.4 0.4-0.4c0.8-0.8 1.9-1.3 3.1-1.3 1.2 0 2.3 0.5 3.1 1.3 1.7 1.7 1.7 4.4 0 6.1l-5.2 5.2c-0.4 0.4-0.9 0.6-1.4 0.6z"
        fill={fill === 'none' ? 'none' : 'transparent'}
        stroke={stroke}
        strokeWidth="1"
      />
    </svg>
  );
};

HeartIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
  stroke: PropTypes.string,
  className: PropTypes.string,
};

export default HeartIcon;